import {loadBlockLazyImages} from "../helpers/lazy-load";
import {MasonryGrid} from "../helpers/masonry-grid";
import {breakpointDown} from "../utils/breakpoints";

/**
 * variable localize_script.admin_ajax - comes from WP setup
 * Required: jquery, MasonryGrid
 * variable canLoad - waits till ajax action is finished
 * to work MasonryGrid add class js-masonry-grid-el to post columns and set true attribute data-masonry-grid
 *
 * Usage:
 */
export class LoadMore {

  constructor (loadMoreBlock) {

    this.block = loadMoreBlock
    this.container = this.block.find('.js-load-more-container')
    this.button = this.block.find('.js-load-more-button')
    this.buttonBlock = this.block.find('.js-load-more-button-block')
    this.changeCategoryButtons = this.block.find('.js-filter-button')
    this.changeSubCategoryButtons = this.block.find('.js-sub-filter-button')

    this.progressbarTotal = this.block.find('.js-total-posts-count')
    this.progressbarLoaded = this.block.find('.js-loaded-posts-count')
    this.progressbarProgress = this.block.find('.js-loaded-posts-progress')
    this.loader = this.block.find('.js-loader')

    this.useMasonryGrid = this.block.attr('data-masonry-grid')
    this.masonryGrid = ''
    this.action = this.block.attr('data-action')
    this.page = parseInt(this.block.attr('data-page'))
    this.totalPosts = parseInt(this.block.attr('data-total-posts'))
    this.perPage = parseInt(this.block.attr('data-per-page'))
    this.loadedPosts = parseInt(this.block.attr('data-loaded-posts'))
    this.cardTemplate = this.block.attr('data-card-template')
    this.cardContainerClass = this.block.attr('data-card-container-class')
    this.postType = this.block.attr('data-post-type')
    this.taxonomy = this.block.attr('data-taxonomy')
    this.activeTermIdString = this.block.attr('data-active-term-id-arr')
    this.activeSubTermIdString = this.block.attr('data-active-sub-term-id-arr')
    this.activeTermUrl = this.block.attr('data-active-url')

    this.activeTermIdArr = this.activeTermIdString.length ? this.activeTermIdString.split(',') : [];
    this.activeSubTermIdArr = this.activeSubTermIdString.length ? this.activeSubTermIdString.split(',') : [];

    this.canLoad = true
    this.totalPages = Math.ceil(this.totalPosts / this.perPage)
    this.changedSubCategoryFlag = false

    this.updateLoadMore()

    this.showHideSubFilters()

    let self = this

    // init masonry grid if enabled
    if (breakpointDown('xl')){
      this.useMasonryGrid = true
      this.masonryGrid = new MasonryGrid(this.container)

    } else {
      this.useMasonryGrid = false
    }


    // load more button click event
    if (this.button.length)
      this.button.click( () => self.nextPage() );

    // change category button click event
    this.changeCategoryButtons.change(()=> self.changeCategory())

    // change sub category button click event
    this.changeSubCategoryButtons.change(()=> self.changeSubCategory())

    // uncheck active category
    $('.filter-btn label').click(function(e){
      if ($(this).closest('.filter-btn').find('input').is(':checked')) {
        e.preventDefault()
        //$('.js-filter-button[value=""]').prop('checked', true)
        $('.js-filter-button[value=""]').click()
      }
    })


    // $('.element-checkbox label').click(function(e){
    //   let checkedCount = 0
    //
    //   $(this).closest('.js-sub-filters').find('input').each(function (){
    //     if ($(this).is(':checked')) checkedCount++
    //   })
    //
    //   if ($(this).closest('.element-checkbox').find('input').is(':checked') && checkedCount <= 1) {
    //     e.preventDefault()
    //   }
    // })

  }

  nextPage() {

    this.loadPage(this.page + 1)

  }

  changeCategory() {
    let self = this
    self.activeTermIdArr = []

    // reset sub categories
    self.activeSubTermIdArr = []
    $('.js-sub-filter-button').prop('checked', false)

    $('input.js-filter-button:checked').each(function () {
      self.activeTermIdArr.push( $(this).val() );
      self.activeTermUrl = $(this).data('url');
    })

    this.loadPage(1, 1)

  }

  changeSubCategory(){
    let self = this
    self.activeSubTermIdArr = []
    self.changedSubCategoryFlag = true

    $('input.js-sub-filter-button:checked').each(function () {
      self.activeSubTermIdArr.push( $(this).val() );
    })

    this.loadPage(1, 1)

  }

  showHideSubFilters(){
    let subFilters = $('.js-sub-filters')
    let activeCategoryArr = this.activeTermIdArr
    let activeSubCategory = this.activeSubTermIdArr
    let self = this
    subFilters.hide()

    subFilters.each(function(i, el){
      let parent = $(el).data('parent').toString()
      if (  activeCategoryArr.includes( parent ) ){
        $(el).show()

        if (!self.changedSubCategoryFlag) {
          $(el).find('input').each(function () {
            $(this).prop('checked', true)
          })
        }

      }
    })

    self.changedSubCategoryFlag = false

  }

  loadPage(page, change_category = 0) {
    const self = this

    if(!self.canLoad) return false
    if(page > self.totalPages) return false

    this.button.hide()
    this.loader.show()

    self.page = page

    $.ajax({
      type: 'GET',
      url: localize_script.admin_ajax,
      data: {
        action: self.action,
        offset: (self.page - 1) * self.perPage,
        perPage: self.perPage,
        cardTemplate: self.cardTemplate,
        cardContainerClass: self.cardContainerClass,
        postType: self.postType,
        taxonomy: self.taxonomy,
        activeTermIdString: self.activeTermIdArr.toString(),
        activeSubTermIdString: self.activeSubTermIdArr.toString(),
      },
      success: function (response) {
        self.loader.hide()
        self.button.show()

        let responseHtml = $(response.html)
        loadBlockLazyImages(responseHtml)

        if (change_category){

          if (self.useMasonryGrid){
            self.masonryGrid.destroy();
          }

          self.container.html(responseHtml)

          if (self.useMasonryGrid){
            self.masonryGrid.init();
          }

        } else {
          self.container.append(responseHtml)
          if (self.useMasonryGrid){
            self.masonryGrid.append(responseHtml)
          }

        }

        self.totalPages = Math.ceil(response.totalPosts / self.perPage)
        self.totalPosts = response.totalPosts
        self.loadedPosts = ((self.page - 1) * self.perPage) + response.loadedPosts

        self.updateData()

        self.updateLoadMore()

        self.showHideSubFilters()

        self.updateUrl()

        self.canLoad = true
      }
    })

  }

  updateData() {
    this.block.attr('data-page', this.page)
    this.block.attr('data-total-posts', this.totalPosts)
    this.block.attr('data-term-id', this.activeTermIdArr)
    this.block.attr('data-active-url', this.activeTermUrl)
    this.block.attr('data-loaded-posts', this.loadedPosts)

  }

  updateLoadMore(){
    let progress = 100 / this.totalPosts * this.loadedPosts

    this.progressbarTotal.text(this.totalPosts)
    this.progressbarLoaded.text(this.loadedPosts)
    this.progressbarProgress.css('width', progress + '%')

    if (this.perPage >= this.totalPosts){
      this.buttonBlock.hide()
    } else {
      this.buttonBlock.show()
    }

    if(this.page >= this.totalPages) {
      this.button.hide()
    } else {
      this.button.show()
    }
  }



  updateUrl() {

    if (window.history && window.history.pushState) {
      //let curUrl = window.location.href.split(/[?#]/)[0]
      let curUrl = this.activeTermUrl
      let newUrlData = ''

      if (this.page > 1) newUrlData = newUrlData + '?lpp=' + this.page;
      //if (this.activeTermIdArr) newUrlData += '&category=' + this.activeTermIdArr.toString()
      if (this.activeSubTermIdArr.length) {
        if (newUrlData.length) {
          newUrlData = newUrlData + '&'
        } else {
          newUrlData = '?'
        }
        newUrlData += 'sub-category=' + this.activeSubTermIdArr.toString();
      }

      history.pushState({}, null, curUrl + newUrlData)
    }

  }

}
